import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import tl from "./locales/tl.json";

// Support languages
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      tl: { translation: tl },
      fil: { translation: tl },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "es", "tl", "fil"],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "navigator", "htmlTag", "localStorage"],
      caches: [],
    },
  });

export default i18n;
